import { createSlice } from '@reduxjs/toolkit';
import modifyField from '@/utils/redux/modifyField';
export const initialState = {
    modals: {
        tollRoadsHint: {
            visibility: false,
            defaultValues: {}
        }
    }
};
export const financesSlice = createSlice({
    name: 'finances',
    initialState,
    reducers: {
        setFinancesPopup: {
            reducer(state, action) {
                const { modal, visibility, defaultValues } = action === null || action === void 0 ? void 0 : action.payload;
                state.modals = modifyField(state.modals, modal, {
                    visibility,
                    defaultValues: Object.assign(Object.assign({}, state.modals[modal].defaultValues), defaultValues)
                });
            },
            prepare(modal, visibility, defaultValues) {
                return { payload: { modal, visibility, defaultValues } };
            }
        }
    }
});
const { setFinancesPopup } = financesSlice.actions;
export const FinancesActionCreators = { setFinancesPopup };
export default financesSlice.reducer;
